var modules_95586cb6 = {"container":"NumberInput_module_container__4d920be8"};
import "../../../assets/esm/components/NumberInput/src/NumberInput~DZbTsKAN.css";

export { modules_95586cb6 as default };
//# sourceMappingURL=NumberInput.module.less.js.map
